<template>
  <div class="deposit-panel-filter" :class="[address ? 'not-connected' : '']">
    <div class="deposit-panel-filter-wrapper">
      <div class="deposit-panel-filter-overlay" @click="toggle()" />
      <app-input
        disabled
        placeholder="Filter"
        inputClass="app-modal-input-sort"
        inputIconLeftClass="filter-icon"
        :inputStyle="'padding-left: 35px;'"
        :inputIconRightClass="{
          'chevron-icon': true,
          active: showFilters,
        }"
      />
    </div>
    <teleport to="body">
      <div
        class="filtering-options-overlay"
        v-if="showFilters"
        @click="toggle"
      />
    </teleport>
    <div class="filtering-options" v-if="showFilters">
      <h2 class="filtering-options-heading">Filter by</h2>
      <h3 class="filtering-options-heading">Network</h3>
      <app-checkbox
        id="6"
        class="filtering-option-checkbox"
        :styleClass="'marketplace'"
        labelText="Ethereum"
        :checked="isChecked('network', 'ethereum')"
        @click="filter({ type: 'network', value: 'ethereum' })"
      />
      <app-checkbox
        id="7"
        labelText="Polygon"
        :styleClass="'marketplace'"
        class="filtering-option-checkbox"
        :checked="isChecked('network', 'polygon')"
        @click="filter({ type: 'network', value: 'polygon' })"
      />
      <h3 class="filtering-options-heading">Type of media</h3>
      <app-checkbox
        v-for="(item, index) in sortFilterOptions.filterMediaArray"
        :key="index"
        :id="index"
        :labelText="item.labelText"
        :styleClass="'marketplace'"
        class="filtering-option-checkbox"
        :checked="isChecked(item.type, item.value)"
        @click="filter({ type: item.type, value: item.value })"
      />
      <h3 class="filtering-options-heading">Price range</h3>
      <app-checkbox
        v-for="(item, index) in sortFilterOptions.filterPriceRangeArray"
        :key="index"
        :id="index"
        :labelText="item.labelText"
        :styleClass="'marketplace'"
        class="filtering-option-checkbox"
        :checked="isChecked(item.type, item.priceRange)"
        @click="filter({ type: item.type, priceRange: item.priceRange })"
      />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import AppInput from "@/elements/AppInput";
import AppCheckbox from "@/elements/AppCheckbox";
import useProfileView from "@/composables/useProfileView";
import sortFilterOptions from "@/json/marketplaceSortFilterOptions";

export default {
  components: {
    AppInput,
    AppCheckbox,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    sortFunction: {
      type: Function,
      default: () => {},
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const showFilters = ref(false);
    const filtersFlag = ref(false);
    const { isChecked, filter } = useProfileView(useStore());

    const toggle = () => {
      showFilters.value = !showFilters.value;
    };

    const setFiltersFlag = (flag) => {
      filtersFlag.value = flag;
    };
    return {
      toggle,
      filter,
      isChecked,
      showFilters,
      setFiltersFlag,
      sortFilterOptions,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/Sort.scss" />
